import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import accountActions from "../../../store/actions/accounts/account.actions";
import { Link, useSearchParams } from "react-router-dom";

import "../../../styles/components/dialogs/accounts/manageAccountsDialogComponent.scss";
import AlertService from "../../../services/alerts/alert.service";
import validationHelper from "../../../helpers/validation.helper";
import { useEffect } from "react";

export const ManageBusinessAccountsDialogComponent = ({ accountActions, accounts }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      await accountActions.getUsersByBusinessCustomer(); // Adjust the action to fetch all accounts
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  const handleUpdate = (id) => {
    const queryParams = new URLSearchParams();
    queryParams.set("d", "account");
    queryParams.set("action", "update");
    queryParams.set("id", id);

    setSearchParams(queryParams);
  };

  const handleDelete = async (email) => {
    const userChoice = await AlertService.confirm("האם אתה בטוח שברצונך למחוק חשבון זה?", "שים לב, פעולה זו בלתי הפיכה", "כן מחק", "בטל");
    if (!userChoice) return;

    const response = await accountActions.deleteAccount(email);
    if (!validationHelper.validateHttpResponse(response)) {
      AlertService.error("מחיקת חשבון נכשלה. נסה שוב.", "אנא נסה שנית מאוחר יותר");
      return;
    }
    AlertService.success("חשבון נמחק בהצלחה");
    fetchAccounts();
  };

  const getNewAccountContainerElement = () => {
    return (
      <div className="newAccountContainer">
        <Link to="?d=account&action=add" className="addAccountButton primaryButton">
          הוספה
        </Link>
      </div>
    );
  };

  const getExistingAccountsContainerElement = () => {
    return (
      <div className="existingAccountTable">
        <div className="tableHeader">
          <div>דוא"ל</div>
          <div>קוד חברה</div>
          <div>שם</div>
          <div>פעולות</div>
        </div>
        <div className="tableBody">
          {accounts?.map((account) => (
            <div key={account.id} className="tableRow">
              <div className="accountEmail">{account.email}</div>
              <div className="accountUsername">{account.businessCustomer.customerId}</div>
              <div className="accountUsername">{account.businessCustomer.lastName}</div>
              <div className="accountActions">
                {/* <button className="actionButton updateButton" onClick={() => handleUpdate(account.id)}>
                  <i className="fa-solid fa-pen-to-square"></i>
                </button> */}
                <button className="actionButton deleteButton" onClick={() => handleDelete(account.email)}>
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="dialogContainer manageAccountsDialogContainer">
      <h1>ניהול חשבונות</h1>
      {getNewAccountContainerElement()}
      {getExistingAccountsContainerElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  accounts: state.accountReducer.usersByBusiness, // Subscribe to accounts state from the reducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageBusinessAccountsDialogComponent);
